var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"router",attrs:{"to":"/configuracoes/logs"}},[(_vm.percentual_uso >= 90)?_c('div',{staticClass:"aviso"},[_c('p',[_vm._v("Alerta: Espaço em disco livre está muito baixo! Percentual de uso: "+_vm._s(_vm.percentual_uso)+" %")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }